var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-overlay",attrs:{"id":"promotion-overlay"}},[(_vm.promotionFrameSrc)?_c('iframe',{staticClass:"modal",attrs:{"src":_vm.promotionFrameSrc}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }